<template>
  <div class="trail-avatar" :style="style">
    <div class="avatar-bounce">
      <!-- Hiker character (inline SVG) -->
      <svg width="36" height="44" viewBox="0 0 36 44" fill="none" class="drop-shadow-lg">
        <!-- Body -->
        <circle cx="18" cy="10" r="8" fill="#fbbf24" /> <!-- Head -->
        <circle cx="14" cy="8" r="1.5" fill="#1e293b" /> <!-- Left eye -->
        <circle cx="22" cy="8" r="1.5" fill="#1e293b" /> <!-- Right eye -->
        <path d="M15 13 Q18 16 21 13" stroke="#1e293b" stroke-width="1.2" fill="none" /> <!-- Smile -->

        <!-- Hat -->
        <ellipse cx="18" cy="4" rx="9" ry="2.5" fill="#16a34a" />
        <rect x="12" y="1" width="12" height="4" rx="2" fill="#16a34a" />

        <!-- Body / shirt -->
        <rect x="12" y="18" width="12" height="12" rx="3" fill="#3b82f6" />

        <!-- Backpack -->
        <rect x="24" y="18" width="6" height="10" rx="2" fill="#ef4444" />
        <rect x="25" y="20" width="4" height="3" rx="1" fill="#fca5a5" />

        <!-- Legs -->
        <rect x="13" y="30" width="4" height="10" rx="2" fill="#64748b" />
        <rect x="19" y="30" width="4" height="10" rx="2" fill="#64748b" />

        <!-- Boots -->
        <rect x="12" y="38" width="6" height="4" rx="2" fill="#92400e" />
        <rect x="18" y="38" width="6" height="4" rx="2" fill="#92400e" />

        <!-- Walking stick -->
        <line x1="8" y1="16" x2="6" y2="40" stroke="#a16207" stroke-width="2" stroke-linecap="round" />
      </svg>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  x: { type: Number, required: true },
  y: { type: Number, required: true }
});

const style = computed(() => ({
  position: 'absolute',
  left: `${props.x - 18}px`,
  top: `${props.y - 52}px`,
  transition: 'left 0.6s ease, top 0.6s ease',
  zIndex: 20,
  pointerEvents: 'none'
}));
</script>

<style scoped>
.avatar-bounce {
  animation: hiker-bounce 2s ease-in-out infinite;
}

@keyframes hiker-bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}
</style>
